import {
  IEigentuemerwechselResponseBody,
  IEigentuemerwechselBody,
  IAddressData,
} from "../../store/slices/eigentuemerwechsel";
import { ISepaUserData } from "../../store/slices/sepa";
import { adminInstance, instance, userInstance } from "../api";

const create = (data: IEigentuemerwechselBody, file?: File[]) => {
  const formData = new FormData();
  (Object.entries(data) as [string, string | undefined][]).forEach(
    ([k, v]) => v != null && formData.append(k, v),
  );
  if (file?.length) {
    file.forEach((f) => formData.append("file", f));
  }
  return instance.post("/eigentuemerwechsel", formData).then((res) => res.data);
};

const getAdminEigentuemerwechselData = ({
  signal,
  direction,
  endDate,
  page,
  pageSize,
  payerType,
  searchValue,
  sort,
  startDate,
  status,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  payerType?: string[];
}) => {
  return adminInstance
    .get<{ data: IEigentuemerwechselResponseBody[]; totalCount: number }>(
      "/admin/eigentuemerwechsel",
      {
        params: {
          direction,
          endDate,
          page,
          pageSize,
          payerType,
          searchValue,
          sort,
          startDate,
          status,
        },
        signal,
      },
    )
    .then((res) => res.data);
};

const getAdminEigentuemerwechselItemById = (id: string) => {
  return adminInstance
    .get<IEigentuemerwechselResponseBody>(`/admin/eigentuemerwechsel/${id}`)
    .then((res) => res.data);
};

const geEigentuemerwechselDoc = (id: string) => {
  return adminInstance
    .get(`/admin/eigentuemerwechsel/${id}/pdf`, {
      responseType: "blob",
    })
    .then((res) => {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", `Eingetuemerwechsel.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};

const checkRegulierer = ({ objektId }: { objektId: string | number }) => {
  return userInstance
    .get<{
      isReguliererPresent: boolean;
      number: null | number;
      user?: ISepaUserData;
    }>(`/eigentuemerwechsel/address-data`, {
      params: {
        objektId,
      },
    })
    .then((res) => res.data);
};
const getAddressData = () => {
  return userInstance
    .get<IAddressData>(`/eigentuemerwechsel/data`)
    .then((res) => res.data);
};

const getAdminItemPdfByPdfName = (id: string, pdfName: string) => {
  return adminInstance
    .get(`/admin/eigentuemerwechsel/${id}/pdf/${pdfName}`, {
      responseType: "blob",
    })
    .then((res) => {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", `${pdfName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};

const updateItemStatusById = ({
  id,
  status,
}: {
  id: string;
  status: string;
}) => {
  return adminInstance
    .put<IEigentuemerwechselResponseBody>(`/admin/eigentuemerwechsel/${id}/status`, {
      status,
    })
    .then((res) => res.data);
};

const Eigentuemerwechsel = {
  get: {
    getAdminEigentuemerwechselData,
    getAdminEigentuemerwechselItemById,
    geEigentuemerwechselDoc,
    checkRegulierer,
    getAddressData,
    getAdminItemPdfByPdfName,
  },
  post: {
    create,
  },
  put: {
    updateItemStatusById,
  },
};

export default Eigentuemerwechsel;
